'use client';

import { useTranslations } from 'next-intl';
import { useCartStore } from 'components/shared/Cart/store/CartStoreContext';
import type { CartAppliedGiftCard } from 'lib/commerce/cart/types';
import { giftCardDesignFor } from 'lib/gifting/giftCardDesigns';
import { GIFT_CARD_NOTE_DEFAULT, GIFT_CARD_NOTES } from './giftCardNotes';
import styles from './GiftCardAppliedBanner.module.css';

/** "Gift card ••••67d4 applied." per card on the cart, in that card design's wording. */
export function GiftCardAppliedBanner() {
  const t = useTranslations('cart');
  const cards = useCartStore(
    (s) => s.cart?.appliedGiftCards as CartAppliedGiftCard[] | undefined,
  );
  if (!cards?.length) return null;

  return (
    <div className={styles.banner} role="status">
      {cards.map((card) => {
        const finish = giftCardDesignFor(card.lastCharacters);
        const { icon: Icon, message } = finish
          ? GIFT_CARD_NOTES[finish]
          : GIFT_CARD_NOTE_DEFAULT;
        return (
          <div key={card.lastCharacters} className={styles.note}>
            <Icon className={styles.icon} />
            <p className={styles.text}>
              {t(message as 'sharedCart.giftCard.banner', {
                last4: card.lastCharacters,
              })}
            </p>
          </div>
        );
      })}
    </div>
  );
}
